import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Title = styled.h2`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 1rem;
  line-height: 1rem;
  color: ${props => props.theme.colors.color545e6c};
`

export const BreastCancerPrsLink = styled(Link)`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  text-decoration-line: underline;
  color: ${props => props.theme.colors.color378ff7};

  display: flex;
  align-self: baseline;
  justify-content: end;
  gap: 3px;
`
